import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managerRemoveEmployees'

export default (managerId, employeeIds) => (asyncAction(
  name,
  ManagersService.removeEmployees,
  { managerId, employeeIds }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managerRemoveEmployees.js